import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'serial'
})
export class SerialPipe implements PipeTransform {
  transform(value, separator: string = ' ') {
    if (!value) {
      return null;
    }
    return ('' + value).replace(/(.{5})/g, '$1' + separator);
  }
}
